/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ExpandIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "expand", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M18.5 6.5L14 11", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M14 6.5H18.5V11", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M6.5 18.5L11 14", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M11 18.5H6.5L6.5 14", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ExpandIcon);
export default ForwardRef;
//# sourceMappingURL=expandIcon.js.map